import { render, staticRenderFns } from "./report-info.vue?vue&type=template&id=0273a59b&scoped=true&"
import script from "./report-info.vue?vue&type=script&lang=js&"
export * from "./report-info.vue?vue&type=script&lang=js&"
import style0 from "./report-info.vue?vue&type=style&index=0&id=0273a59b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273a59b",
  null
  
)

export default component.exports